import { SET_TRUTHY_CART_VALUES } from "../../redux/actions/action.types";

export default function setTruthyCartValues(valobj: any, stateHandler: any) {
  stateHandler({
    type: SET_TRUTHY_CART_VALUES,
    payload: valobj,
  });
}
